var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showTitle
        ? _c("div", { staticClass: "d-flex justify-space-between" }, [
            _c("p", { staticClass: "font-weight-black" }, [
              _vm.allowEdit ? _c("span", [_vm._v("EDITAR")]) : _vm._e(),
              _vm._v(" ASISTENCIA"),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-form",
        { ref: "formAgent", attrs: { "lazy-validation": "" } },
        [
          _c(
            "v-row",
            { staticClass: "fill-height px-3 py-2" },
            [
              _c(
                "v-col",
                { staticClass: "d-flex", attrs: { cols: "12" } },
                [
                  _vm.getTicket.agent_id && !_vm.loading
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-avatar",
                            { attrs: { size: "48px", color: "black" } },
                            [
                              _vm.getAllAgentsMap[_vm.getTicket.agent_id].photo
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.getAllAgentsMap[
                                        _vm.getTicket.agent_id
                                      ].photo,
                                      alt: "Avatar",
                                    },
                                  })
                                : _c(
                                    "span",
                                    { staticClass: "white--text text-h5" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getAllAgentsMap[
                                              _vm.getTicket.agent_id
                                            ].full_name.substring(0, 1)
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "v-avatar",
                            { attrs: { size: "50px", color: "black" } },
                            [
                              _c(
                                "span",
                                { staticClass: "white--text text-h5" },
                                [_vm._v("-")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c("v-autocomplete", {
                    staticClass: "pl-2",
                    attrs: {
                      items: _vm.agentsFiltered,
                      value: _vm.getTicket.agent_id,
                      "item-text": "full_name",
                      "item-value": "uid",
                      label: "Agente",
                      placeholder: "Sin asignar",
                    },
                    model: {
                      value: _vm.agentId,
                      callback: function ($$v) {
                        _vm.agentId = $$v
                      },
                      expression: "agentId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.responseMessage
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-alert", { attrs: { text: "", type: "error" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.responseMessage) +
                            "\n        "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allowEdit
                ? _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            loading: _vm.loading,
                            small: "",
                            rounded: "",
                            color: "primary",
                          },
                          on: { click: _vm.onSave },
                        },
                        [_vm._v(" Guardar ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", rounded: "" },
                          on: { click: _vm.onCancel },
                        },
                        [_vm._v(" Cancelar ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }